import React from "react";
import { IonItem, IonIcon } from "@ionic/react";
import styled from "styled-components";

const Container = styled.div`
  margin-top: 8px;
`;
const MenuItem = styled(IonItem)``;
const MenuItemIcon = styled(IonIcon)``;
const MenuItemContainer = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
`;
const MenuItemLabel = styled.div``;
const MenuItemDescription = styled.div`
  font-size: 0.8em;
  color: #666666;
`;

const MenuList = (props) => {
  const menuItems = props.menuItems.map((i, index) => {
    const menuIcon = i.icon ? (
      <MenuItemIcon slot="start" icon={i.icon} />
    ) : null;
    return (
      <MenuItem key={index} onClick={i.onClick} button={true} detail={true}>
        {menuIcon}
        <MenuItemContainer>
          <MenuItemLabel>{i.label}</MenuItemLabel>
          <MenuItemDescription>{i.description}</MenuItemDescription>
        </MenuItemContainer>
      </MenuItem>
    );
  });

  return <Container>{menuItems}</Container>;
};

export default MenuList;
